import { getConfiguredMapId } from '../stores/GoogleMapState'
import { startMarkerIcon, endMarkerIcon } from './marker-icons'

// Advanced Markers only render on a map initialised with a mapId, so the
// configured Map ID doubles as the rollout flag: configured → Advanced
// Markers, blank → legacy google.maps.Marker (instant no-deploy rollback by
// clearing the CMS field). Remove the legacy branch once the Map ID is
// permanent in production (see NZTAJP-565 / docs/ROUTES_API_POST_MIGRATION.md).
export type RouteWaypointMarker = google.maps.Marker | google.maps.marker.AdvancedMarkerElement

type RoutePinPosition = google.maps.LatLng | google.maps.LatLngLiteral

function createWaypointMarker(
  position: RoutePinPosition,
  map: google.maps.Map,
  iconUrl: string,
  altText: string,
): RouteWaypointMarker {
  if (getConfiguredMapId()) {
    const pinImage = document.createElement('img')
    pinImage.src = iconUrl
    pinImage.alt = altText
    return new google.maps.marker.AdvancedMarkerElement({
      position,
      map,
      content: pinImage,
    })
  }

  return new google.maps.Marker({
    position,
    map,
    icon: iconUrl,
  })
}

export function createStartMarker(
  position: RoutePinPosition,
  map: google.maps.Map,
): RouteWaypointMarker {
  return createWaypointMarker(position, map, startMarkerIcon, 'Route start')
}

export function createEndMarker(
  position: RoutePinPosition,
  map: google.maps.Map,
): RouteWaypointMarker {
  return createWaypointMarker(position, map, endMarkerIcon, 'Route end')
}

export function removeWaypointMarker(marker: RouteWaypointMarker | null | undefined): void {
  if (!marker) return
  if (marker instanceof google.maps.Marker) {
    marker.setMap(null)
  } else {
    // AdvancedMarkerElement has no setMap(); detach via the map property
    marker.map = null
  }
}
